import React from "react";

export default function WeeklyTable({ title, rows, setRows }) {
  const editable = !!setRows;

  const updateRow = (id, field, value) => {
    if (!editable) return;
    setRows(rows.map((r) => (r.id === id ? { ...r, [field]: value } : r)));
  };

  const formatNum = (v) => {
    if (v === null || v === undefined || v === "") return "";
    const n = Number(v);
    return isNaN(n) ? v : n.toFixed(2).replace(/\.00$/, "");
  };

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 13, marginBottom: 4 }}>{title}</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 12,
        }}
      >
        {/* ================= HEADER (KEEPS FULL BORDERS) ================= */}
        <thead>
          <tr>
            <th style={th}>COMPANY</th>
            <th style={th}>DRIVER</th>
            <th style={thNumeric}>WEEK1</th>
            <th style={thNumeric}>WEEK2</th>
            <th style={thNumeric}>WEEK3</th>
            <th style={thNumeric}>WEEK4</th>
            <th style={thNumeric}>WEEK5</th>
            <th style={thNumeric}>TOTAL</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r) => {
            const isSummary = r.rowType === "summary";

            return (
              <tr
                key={r.id}
                style={{
                  borderBottom: "1px solid #e5e7eb", // ⭐ ONLY ROW BORDER
                  background: isSummary ? "#f8f9fa" : "white",
                }}
              >
                {/* ================= SUMMARY ROW ================= */}
                {isSummary ? (
                  <>
                    <td
                      colSpan={7}
                      style={{
                        ...tdViewer,
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                    >
                      {r.label}
                    </td>

                    <td style={tdViewerNumeric}>
                      {editable ? (
                        <input
                          type="text"
                          value={r.total || ""}
                          onChange={(e) =>
                            updateRow(r.id, "total", e.target.value)
                          }
                          style={inputNumeric}
                        />
                      ) : (
                        formatNum(r.total)
                      )}
                    </td>
                  </>
                ) : (
                  <>
                    {/* ================= COMPANY / DRIVER ================= */}
                    <td style={editable ? td : tdViewer}>{r.company}</td>
                    <td style={editable ? td : tdViewer}>{r.driver}</td>

                    {/* ================= WEEK VALUES ================= */}
                    {["week1", "week2", "week3", "week4", "week5"].map((wk) => (
                      <td
                        key={wk}
                        style={editable ? tdNumeric : tdViewerNumeric}
                      >
                        {editable ? (
                          <input
                            type="text"
                            value={r[wk] || ""}
                            onChange={(e) =>
                              updateRow(r.id, wk, e.target.value)
                            }
                            style={inputNumeric}
                          />
                        ) : (
                          formatNum(r[wk])
                        )}
                      </td>
                    ))}

                    {/* ================= TOTAL ================= */}
                    <td style={editable ? tdNumeric : tdViewerNumeric}>
                      {editable ? (
                        <input
                          type="text"
                          value={r.total || ""}
                          onChange={(e) =>
                            updateRow(r.id, "total", e.target.value)
                          }
                          style={inputNumeric}
                        />
                      ) : (
                        formatNum(r.total)
                      )}
                    </td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

/* =====================================================
   HEADER STYLES (KEEP FULL BORDER)
===================================================== */
const th = {
  border: "1px solid #ccc",
  padding: "6px 4px",
  background: "#f3f4f6",
  textAlign: "left",
  fontWeight: "bold",
};

const thNumeric = { ...th, textAlign: "right" };

/* =====================================================
   EDITABLE MODE STYLES (UNCHANGED)
===================================================== */
const td = {
  border: "1px solid #e5e7eb",
  padding: 4,
};

const tdNumeric = { ...td, textAlign: "right" };

const input = {
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
  padding: "2px 4px",
  fontSize: 11,
};

const inputNumeric = { ...input, textAlign: "right" };

/* =====================================================
   VIEWER MODE STYLES (ONLY ROW BORDERS)
===================================================== */
const tdViewer = {
  padding: 4,
  border: "none",
  borderBottom: "1px solid #e5e7eb", // ⭐ row-only border
};

const tdViewerNumeric = {
  ...tdViewer,
  textAlign: "right",
};
